import {type ParentalPermission} from './parental-permissions';

export function parentalPermissionsTypePatcher(data: ParentalPermission) {
    return {
        __typename: 'ParentalPermission',
        ...data,
    };
}
